<div class="container">
  <div class="header">
    <span class="capacity" [ngClass]="'c-' + booking?.state_id">
      {{ getStatusName }}
    </span>
    <div class="image">
      <img [src]="booking.coworking.image" alt="" />
    </div>
  </div>
  <div class="info">
    <div class="title">
      {{ booking.coworking.company_name }}
    </div>
    <div class="more-info">
      <div>{{ booking.start_date }}</div>
      <div>{{ booking.end_date }}</div>
      <div>
        <img [src]="getClockActive" alt="" />
        <div>{{ booking.start_time }} a {{ booking.end_time }}</div>
      </div>
    </div>
  </div>
  <div class="actions">
    <div class="price">
      {{ booking.public_price }} {{ "general.cowings" | translate }}
      <div class="seats">
        <img [src]="getSeats" alt="" /> {{ booking.space.capacity }}
      </div>
    </div>
    <div class="action" *ngIf="showCancelButton">
      <cowing-button
        [label]="'general.cancel' | translate"
        [type]="EButtonType.RoundedSecondaryNoMargin"
        [iconShow]="false"
        (event)="showCancel.emit(booking.id)"
      >
      </cowing-button>
    </div>
  </div>
</div>
